"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const UICheck_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/UI/UICheck.vue"));
const GroupAreaSelect_vue_1 = __importDefault(require("@becrop/components/Toolkit/Heatmap2/vue/propbar/components/GroupAreaSelect.vue"));
const debounce_1 = require("@common/tsutils/debounce");
let GroupArea = class GroupArea extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.makeSubgroups = false;
        this.configInstance1 = null;
        this.configInstance2 = null;
        this.configs1 = [];
        this.configs2 = [];
    }
    mounted() {
        this.updateConfigs();
    }
    // Will be called when loading configuration
    onChangeHeatmapConfig1() {
        if (this.configInstance1 !== this.heatmap.groupConfigInstance1) {
            console.warn("Changed externally", this.heatmap.groupConfigInstance1);
            this.configInstance1 = this.heatmap.groupConfigInstance1;
        }
    }
    // Will be called when loading configuration
    onChangeHeatmapConfig2() {
        if (this.configInstance2 === this.heatmap.groupConfigInstance2) {
            console.warn("Changed group externally", this.heatmap.groupConfigInstance2, this.makeSubgroups);
            if (this.heatmap.groupConfigInstance2) {
                this.makeSubgroups = true;
            }
            else {
                this.makeSubgroups = false;
            }
            this.configInstance2 = this.heatmap.groupConfigInstance2;
        }
    }
    updateConfigs() {
        if (this.configInstance1 || this.configInstance2) {
            this.configInstance1 = null;
            this.configInstance2 = null;
        }
        this.configs1 = this.heatmap.availableGroupConfigs();
    }
    onChangeSubgroupCheck() {
        if (!this.makeSubgroups) {
            this.configInstance2 = null;
        }
    }
    onChangeConfig1() {
        this.configInstance2 = null;
        this.configs2 = this.configs1.filter(conf => {
            if (!this.configInstance1)
                return false;
            return this.configInstance1.config !== conf;
        });
    }
    /*
    @Watch('configInstance1', {deep: true})
    onChangeConfig1forDirection(){

        console.log("onChangeConfig1forDirection");

        if(this.configInstance2 && this.configInstance2.direction === 'manual'){
            this.configInstance2.direction = 'asc';
        }

    }
     */
    onChangeConfig1or2() {
        this.emitGroupConfigs();
    }
    emitGroupConfigs() {
        const config1 = this.configInstance1;
        const config2 = this.configInstance2;
        this.heatmap.setGroupConfig(config1, config2);
    }
    expand() {
        this.$emit('ontogglegroup', !this.options.expanded);
    }
    backToDefaultGroups() {
        // console.log("default");
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], GroupArea.prototype, "heatmap", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], GroupArea.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.groupConfigInstance1')
], GroupArea.prototype, "onChangeHeatmapConfig1", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.groupConfigInstance2')
], GroupArea.prototype, "onChangeHeatmapConfig2", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('heatmap.selectedSamples.length')
], GroupArea.prototype, "updateConfigs", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('makeSubgroups')
], GroupArea.prototype, "onChangeSubgroupCheck", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('configInstance1'),
    (0, vue_property_decorator_1.Watch)('configs1')
], GroupArea.prototype, "onChangeConfig1", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('configInstance1', { deep: true }),
    (0, vue_property_decorator_1.Watch)('configInstance2', { deep: true })
], GroupArea.prototype, "onChangeConfig1or2", null);
__decorate([
    (0, debounce_1.Debounce)(1000)
], GroupArea.prototype, "emitGroupConfigs", null);
GroupArea = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Globe: lucide_vue_next_1.Globe,
            ChevronDown: lucide_vue_next_1.ChevronDown,
            Square: lucide_vue_next_1.Square,
            GroupAreaSelect: GroupAreaSelect_vue_1.default,
            UICheck: UICheck_vue_1.default
        }
    })
], GroupArea);
exports.default = GroupArea;
